module.exports = __webpack_public_path__ + "roboto-regular-webfont-42a434b9f3c8c7a57b83488483b2d08e.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-regular-webfont.ttf
// module id = 867
// module chunks = 86